export default __webpack_public_path__ + "static/media/BranchesAndDeliveryMobile.dae20fd3.png";